import { Box, styled } from '@mui/material';

export const ToastActionsWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  gap: theme.spacing(1)
}));

export const ToastText = styled('p')(({ theme }) => ({
  marginBottom: theme.spacing(1),
  wordWrap: 'break-word',
  textAlign: 'left'
}));

export const ToastActionButton = styled('button')(({ theme }) => ({
  width: '40%',
  height: '1.3rem',
  background: theme.palette.primary.main,
  color: '#fff',
  border: 'none',
  borderRadius: '0.4rem',
  outline: 'none',
  fontSize: '0.8rem',
  fontWeight: 'bold',
  boxShadow: '0 0.1rem 0.1rem rgba(0, 0, 0, 0.4)',
  cursor: 'pointer',
  textAlign: 'center',
  '&:active': {
    transform: 'scale(0.95)'
  },
  '&:hover': {
    backgroundColor: theme.palette.primary.light
  }
}));

export const ToastLogAnchor = styled('a', { shouldForwardProp: prop => prop !== 'active' })(({ active }) => ({
  color: active ? 'blue' : 'black',
  cursor: active ? 'pointer' : 'default',
  pointerEvents: active ? 'auto' : 'none'
}));
